import { render, staticRenderFns } from "./InvoiceBankEditForm.vue?vue&type=template&id=2b828f81&"
import script from "./InvoiceBankEditForm.vue?vue&type=script&lang=js&"
export * from "./InvoiceBankEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports